
import React from 'react';

export const COLORS = {
  black: '#1A1A1A',
  cream: '#F5F0E6',
  gold: '#C9A227',
  brown: '#3D2B1F',
  green: '#2D5A3D',
  terracotta: '#A65D3F',
};

export const ScarabIcon = ({ className = "w-8 h-8" }: { className?: string }) => (
  <svg viewBox="0 0 100 100" className={className} fill="currentColor">
    {/* Stylized geometric scarab */}
    <path d="M50 10C35 10 25 25 25 45C25 65 35 90 50 90C65 90 75 65 75 45C75 25 65 10 50 10ZM50 15C62 15 70 28 70 45C70 60 62 82 50 85C38 82 30 60 30 45C30 28 38 15 50 15Z" />
    <path d="M45 5L55 5L55 15L45 15Z" />
    <circle cx="50" cy="30" r="5" />
    <path d="M20 40Q10 40 10 30" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M80 40Q90 40 90 30" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M20 60Q10 60 10 70" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M80 60Q90 60 90 70" fill="none" stroke="currentColor" strokeWidth="2" />
  </svg>
);
